exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav.nav-bar .el-badge__content.is-fixed{right:0}.el-tabs--bottom .el-tabs__header.is-bottom{margin-top:0}.el-tabs__item{font-weight:700;font-size:15px;padding:0 12px!important}.el-tabs__active-bar{color:#ec1c1c;background-color:#ec1c1c}.el-tabs__item.is-active,.el-tabs__item:hover{color:#ec1c1c}.el-tabs__nav-wrap:after{height:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d080004","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./pages/signInfo.vue
// module id = jQ1p
// module chunks = 23